import wordings from '../utils/wordings';
import wordDirective from '../directives/word';

export default {
  props: ['wordingsOverride', 'wordingsEditable', 'wordingsMeta', 'editMode'],

  data() {
    return {
      loadedWordings: {},
      loadingDone: false,
    };
  },

  computed: {
    wordings() {
      return this.wordingsOverride || this.loadedWordings;
    },
  },

  mounted() {
    if (!this.wordingsOverride && !this.loadingDone) {
      this.$emit('loadingWordings');
      wordings()
        .then(wordings => {
          this.$emit('loadedWordings');
          this.loadingDone = true;
          this.loadedWordings = wordings;
        })
        .catch(() => {
          this.$emit('failedWordings');
        });
    }
  },

  methods: {
    onWordingChange(change) {
      this.$emit('wordingChange', change);
    },
    runWordingCommand(command) {
      this.$emit('runWordingCommand', command);
    },
  },

  directives: {
    word: wordDirective,
  },
};



// WEBPACK FOOTER //
// ./src/mixins/worded-page.js